import React, { useEffect, useState } from 'react';
const houses = [{
  title: '& the Table Official House',
  price: 'Free',
  description: "Even though we've grown into a larger platform as a place for women to host their supper clubs &...",
  location: 'Global',
  members: 136,
  image: 'https://cdn.magicpatterns.com/uploads/76XSyWSHt3vfihF2JmZPzp/A_LIFE_WELL_LIVED_.jpg',
  link: 'https://partiful.com/e/bgg231bgLaWYImRp1ZCw'
}, {
  title: "Sam's House",
  price: 'Free',
  description: "A house for the women who've already shared a seat at my table, my close friends. A place where...",
  location: 'Amsterdam, Philadelphia',
  members: 10,
  image: 'https://cdn.magicpatterns.com/uploads/f82H39uTeQzE3Bn7MuJMRX/THE_FOOD_THAT_BINDS_US.jpg',
  link: 'https://partiful.com/e/bgg231bgLaWYImRp1ZCw'
}, {
  title: 'For the Love of Tables',
  price: '€19/quarter',
  description: 'A house for the women who believe a table is never just a table. This is a global home for the detail-...',
  location: 'Global',
  members: 12,
  image: 'https://cdn.magicpatterns.com/uploads/iPmAaSzztqB7p1KJ6oj2Em/TRAVELLING_WITH_INTENTION_(1).jpg',
  link: 'https://partiful.com/e/bgg231bgLaWYImRp1ZCw'
}, {
  title: 'The Lisbon Table',
  price: 'Free',
  description: 'An intimate gathering for women building lives abroad. We talk about what home means when you chose...',
  location: 'Lisbon, Portugal',
  members: 8,
  image: 'https://cdn.magicpatterns.com/uploads/12UL2BjaW7duW7moeYjXef/DIGITAL_COUNTRIES_AND_TRIBES.jpg',
  link: 'https://partiful.com/e/bgg231bgLaWYImRp1ZCw'
}, {
  title: 'Supper & Stories',
  price: 'Free',
  description: 'A monthly dinner where every course comes with a prompt. We eat, we share, we leave feeling less...',
  location: 'London, UK',
  members: 24,
  image: 'https://cdn.magicpatterns.com/uploads/kx6yxj4jtvF7r8f2rtDLC3/Making_money_from_everywhere_(1).jpg',
  link: 'https://partiful.com/e/bgg231bgLaWYImRp1ZCw'
}, {
  title: 'Tables Without Borders',
  price: '€9/quarter',
  description: 'For the nomads who crave roots at the table. A rotating city, a shared meal, a conversation that...',
  location: 'Global',
  members: 31,
  image: 'https://cdn.magicpatterns.com/uploads/h3pHGnis1db4tQhJBzgsqW/DIGITAL_COUNTRIES_AND_TRIBES_2.jpg',
  link: 'https://partiful.com/e/bgg231bgLaWYImRp1ZCw'
}];
const LocationIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-111">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-112" />
    <circle cx="12" cy="10" r="3" data-id="element-113" />
  </svg>;
const MembersIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-114">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" data-id="element-115" />
    <circle cx="9" cy="7" r="4" data-id="element-116" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" data-id="element-117" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-118" />
  </svg>;
const animationImages = ['https://cdn.magicpatterns.com/uploads/x4pFi4mqmTzraNNEn7TnKC/Untitled_design.png', 'https://cdn.magicpatterns.com/uploads/7dNwRxM3wC5yo6h35RBJT8/1.png', 'https://cdn.magicpatterns.com/uploads/he78B4SWjKpvLq4ESLN8JV/2_.png', 'https://cdn.magicpatterns.com/uploads/saWChcpXBFnNefupqho7VW/3.png'];
type AnimationPhase = 'idle' | 'shaking' | 'frame1' | 'frame2' | 'frame3' | 'revealed';
export function DinnersPage() {
  const [phase, setPhase] = useState<AnimationPhase>('idle');
  const [imagesLoaded, setImagesLoaded] = useState(false);
  // Preload all animation images on mount
  useEffect(() => {
    let loaded = 0;
    animationImages.forEach(src => {
      const img = new Image();
      img.onload = () => {
        loaded++;
        if (loaded === animationImages.length) {
          setImagesLoaded(true);
        }
      };
      img.onerror = () => {
        loaded++;
        if (loaded === animationImages.length) {
          setImagesLoaded(true);
        }
      };
      img.src = src;
    });
  }, []);
  const startAnimation = () => {
    if (phase !== 'idle') return;
    // Sequence: Shake -> Frame 1 -> Frame 2 -> Frame 3 -> Revealed
    setPhase('shaking');
    // 1. Shake for 800ms
    setTimeout(() => {
      setPhase('frame1');
      // 2. Show Frame 1 for 400ms
      setTimeout(() => {
        setPhase('frame2');
        // 3. Show Frame 2 for 400ms
        setTimeout(() => {
          setPhase('frame3');
          // 4. Show Frame 3 for 400ms then reveal
          setTimeout(() => {
            setPhase('revealed');
          }, 400);
        }, 400);
      }, 400);
    }, 800);
  };
  const isRevealed = phase === 'revealed';
  // Helper to determine which image index to show
  const getCurrentImageIndex = () => {
    switch (phase) {
      case 'idle':
      case 'shaking':
        return 0;
      case 'frame1':
        return 1;
      case 'frame2':
        return 2;
      case 'frame3':
        return 3;
      default:
        return -1;
    }
  };
  const currentIndex = getCurrentImageIndex();
  return <main className="w-full bg-white px-4 sm:px-6 md:px-12 pt-16 pb-32" data-id="element-119">
      <h1 className="text-[32px] sm:text-[42px] md:text-[56px] font-normal text-black mb-16 tracking-tight" data-id="element-120">
        Dinners.
      </h1>

      <div className="flex flex-col items-center relative" data-id="element-121">
        {/* Animation Container */}
        {!isRevealed && <div className="flex items-center justify-center relative z-20 w-full" data-id="element-122">
            <div className="min-h-[300px] md:min-h-[600px] flex items-center justify-center w-full relative" data-id="element-123">
              {animationImages.map((src, i) => {
            const isPaper = i > 0; // frames 1, 2, 3 are the paper pieces
            return <img key={src} src={src} alt="Dinner invitation animation" onClick={startAnimation} className={`cursor-pointer select-none w-full absolute ${isPaper ? 'max-w-[900px]' : 'max-w-[520px]'} ${phase === 'shaking' && i === 0 ? 'animate-shake' : ''}`} style={{
              opacity: currentIndex === i ? 1 : 0,
              transition: 'opacity 0.05s ease'
            }} draggable={false} data-id="element-124" />;
          })}
            </div>
          </div>}

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 w-full max-w-[1100px] mx-auto relative z-10" data-id="element-125">
          {houses.map((house, i) => <a key={i} href={house.link} target="_blank" rel="noopener noreferrer" className="block" style={{
          opacity: isRevealed ? 1 : 0,
          transform: isRevealed ? 'translateY(0)' : 'translateY(40px)',
          transition: `opacity 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 0.1}s, transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 0.1}s`
        }} data-id="element-126">
              <img src={house.image} alt={house.title} className="w-full rounded-sm" style={{
            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.03)';
            e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.15)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = 'none';
          }} draggable={false} data-id="element-127" />
            </a>)}
        </div>
      </div>
    </main>;
}